import React, { useEffect } from 'react';
import { Wrench, Clock, Mail, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function MaintenancePage() {
  useEffect(() => {
    // Prevent crawling of the maintenance page
    document.title = 'Cloudbase - En Mantención';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-gray-900 to-black text-white relative overflow-hidden"
      data-testid="maintenance-page"
    >
      {/* Background accents */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-10 -left-20 w-96 h-96 bg-green-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 -right-20 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Logo */}
          <img
            src="https://customer-assets.emergentagent.com/job_smart-workspaces/artifacts/joupqq6v_logo_blue_horizontal.png"
            alt="Cloudbase"
            className="brightness-0 invert mx-auto mb-12"
            style={{ height: '4rem' }}
          />

          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-green-600/20 border-2 border-green-500/40">
              <Wrench className="w-12 h-12 text-green-400 animate-pulse" />
            </div>
          </div>

          {/* Title */}
          <div className="inline-block mb-6 px-4 py-2 bg-green-600/20 border border-green-600/30 text-green-400 rounded-full text-sm font-semibold">
            Estamos en Mantención
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
            Volvemos pronto
          </h1>

          <p className="text-xl sm:text-2xl text-gray-300 mb-10 leading-relaxed font-light">
            Estamos realizando mejoras en nuestra plataforma para entregarte una mejor
            experiencia. Disculpa las molestias — volveremos a estar disponibles en unos
            minutos.
          </p>

          {/* Time indicator */}
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/5 border border-white/10 rounded-full mb-12">
            <Clock className="w-5 h-5 text-green-400" />
            <span className="text-gray-300">
              Tiempo estimado: <span className="font-semibold text-white">30 minutos</span>
            </span>
          </div>

          {/* Contact options */}
          <div className="max-w-md mx-auto mb-12">
            <a
              href="mailto:soporte@cloudbase.cl"
              className="flex items-center gap-4 p-5 bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg transition-colors text-left group"
              data-testid="maintenance-email-link"
            >
              <div className="w-12 h-12 rounded-lg bg-green-600/20 flex items-center justify-center flex-shrink-0">
                <Mail className="w-6 h-6 text-green-400" />
              </div>
              <div className="flex-1">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1">
                  Email de Soporte
                </div>
                <div className="text-white font-semibold">soporte@cloudbase.cl</div>
              </div>
              <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
            </a>
          </div>

          {/* Retry button */}
          <Button
            size="lg"
            className="bg-green-600 hover:bg-green-700 text-white px-10 py-7 text-base rounded font-semibold transition-all duration-200"
            onClick={() => window.location.reload()}
            data-testid="maintenance-retry-btn"
          >
            Reintentar
          </Button>

          <p className="mt-12 text-gray-500 text-sm">
            © {new Date().getFullYear()} Cloudbase · Plataforma Integrada de Gestión
          </p>
        </div>
      </div>
    </div>
  );
}
